import {NgModule} from '@angular/core';
import {OrganizationRegistrationComponent} from './organization-registration/organization-registration.component';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {ReactiveFormsModule} from '@angular/forms';
import {LayoutModule} from '../../layout-components/layout.module';
import {PasswordRestoreComponent} from './password-restore/password-restore.component';
import {PasswordRestoreRequestComponent} from './password-restore-request/password-restore-request.component';
import {LoginComponent} from './login/login.component';
import {LoginService} from './login/login.service';
import {InnRegistrationComponent} from './organization-registration/inn-registration.component';
import {ManualRegistrationComponent} from './organization-registration/manual-registration.component';
import {InnRegistrationService} from './organization-registration/inn-registration.service';
import {ByTokenOnlyGuardService} from './services/by-token-only-guard.service';
import {ActivationGuardService} from './services/activation-guard.service';
import {RouterModule} from '@angular/router';
import {ActivateInvitationComponent} from './activate-invitation/activate-invitation.component';
import {ActivateInvitedUserService} from './services/activate-invited-user.service';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        RouterModule,
        FormFieldModule,
        CommonModule,
        DirectivesModule,
        ReactiveFormsModule,
        LayoutModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        OrganizationRegistrationComponent,
        PasswordRestoreComponent,
        PasswordRestoreRequestComponent,
        LoginComponent,
        InnRegistrationComponent,
        ManualRegistrationComponent,
        ActivateInvitationComponent,
    ],
    providers: [
        LoginService,
        InnRegistrationService,
        ByTokenOnlyGuardService,
        ActivationGuardService,
        ActivateInvitedUserService,
    ],
})
export class RegistrationModule {
}
